// extracted by mini-css-extract-plugin
export default {"container":"BullCard_container__i4H5m","card":"BullCard_card__Ne2e0"};